/**
 * Lightweight analytics dispatch. Fires to whichever providers are present
 * on the page (GA4/GTM dataLayer, gtag, Plausible) and always emits a
 * `lovable:analytics` CustomEvent so other listeners can subscribe.
 *
 * No-op during SSR.
 */
export type AnalyticsPayload = Record<string, string | number | boolean | undefined | null>;

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    gtag?: (...args: unknown[]) => void;
    plausible?: (event: string, options?: { props?: AnalyticsPayload }) => void;
  }
}

export function trackEvent(event: string, payload: AnalyticsPayload = {}) {
  if (typeof window === "undefined") return;

  try {
    // GA4 / GTM
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event, ...payload });
    }
    if (typeof window.gtag === "function") {
      window.gtag("event", event, payload);
    }
    // Plausible
    if (typeof window.plausible === "function") {
      window.plausible(event, { props: payload });
    }
    // Generic listener hook
    window.dispatchEvent(
      new CustomEvent("lovable:analytics", { detail: { event, ...payload } }),
    );
  } catch {
    // Never let analytics break the UI.
  }
}

export type RelatedArticleClickPayload = {
  slug: string;
  title: string;
  position: number;
  section: string;
  source_path: string;
};

export function trackRelatedArticleClick(payload: RelatedArticleClickPayload) {
  trackEvent("related_article_click", payload);
}